<template>
    <div class="innerBox">
  
      <h1>Journal Entry</h1>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox" style="padding:0 0">
          <div class="col row">
			<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Work Order Code</label>
              
			  <Multiselect 
			  :options="options.workorder_code"
				v-model="filter.workorder_code"
			  />
            </div>
            <div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Account</label>
              <Multiselect 
			  	:options="options.accountTransactionList.map(x => x.id)"
				v-model="filter.account"
				:custom-label="opt => options.accountTransactionList.find(x => x.id == opt).account_name"

			  />
            </div>
			<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Tanggal</label>
              <flat-pickr
                v-model="selected.date"
                :config="rangeConfig"
                placeholder="Pilih Tanggal"
              ></flat-pickr>
            </div>
            <div class="col-md-3" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:42px; margin-bottom:0.5%" @click="updateData">Filter</button>
            </div>
          </div>
        </div>
      </panel>

	  <!-- <div class="row mt-2 mb-2">
		  <div class="col-md-4">
                <stats
                    title="Total Penghasilan"
                    :value="statsData ? 'Rp. ' +  numberWithCommas(statsData.total) : 'Loading...'"
                    icon="dollar-sign"
                    background_color="#FF5B57"
                ></stats>
            </div>
            <div class="col-md-4">
                <stats
                    title="Total Pendapatan"
                    :value="statsData ? 'Rp. ' +  numberWithCommas(statsData.debit) : 'Loading...'"
                    icon="money-bill-wave-alt"
                    background_color="#49B6D6"
                ></stats>
            </div>
            <div class="col-md-4">
                <stats
                    title="Total Pengeluaran"
                    :value="statsData ? 'Rp. ' +  numberWithCommas(statsData.credit) : 'Loading...'"
                    icon="money-check"
                    background_color="#F59C19"
                ></stats>
            </div>
	  </div> -->
  
	  <vue-universal-table
	  	class="mt-3"
	  	api_url="/api/v1/transactions"
		:update="vue_universal_table.update"
		:fields="vue_universal_table.fields"
		:buttons="vue_universal_table.buttons"
		:special_buttons="vue_universal_table.special_buttons"
		:filter="filter"
		:export_config="vue_universal_table.export_config"
		@onCekDetailTransaksi="goToEstimator"
		:process_data="vue_universal_table.process_data"
      ></vue-universal-table>
  
    </div>
  </template>
  
  <script>  
	import Multiselect from 'vue-multiselect'
	import moment from 'moment'
	import qs from 'qs'
	import stats from './children/smallStats'

    export default {
		components : {
			Multiselect,
			stats
		},
		data () {
			const start = moment()
				.subtract(5, "months")
				.startOf("month")
				.format("YYYY-MM-DD");
			let end = new moment().add(1 , 'day').format("YYYY-MM-DD");

			return {
				mobile : this.isMobile(),
				modal : {
					view : false,
				},
				rangeConfig: {
					mode: 'range',
					altInput: true,
					altInputClass: 'form-control input flatpickr-input w-100',
					animate: !this.isRTL()
				},
				statsData : null,
				detailId : '',
				selected : {
					date : `${start} to ${end}`,
				},
				options : {
					workorder_code : [],
					accountTransactionList : []
				},
				filter : {
					workorder_code : '',
					start : start,
					end : end
				},
				vue_universal_table : {
					fields : [
						{
							title : 'Tanggal',
							variable : 'created_at'
						},
						{
							title : 'Nomor WO',
							variable : 'workorder_code'
						},
						{
							title : 'Account',
							variable : 'name'
						},
						{
							title : 'Deskripsi',
							variable : 'description'
						},
						{
							title : 'Debit',
							variable : 'debit',
							number_formatting : true
						},
						{
							title : 'Credit',
							variable : 'credit',
							number_formatting : true	
						},
						{
							title : 'Account' ,
							variable : 'account_name'
						}
						
					],
					process_data : `
						for(var i = 0 ; i < data.length ; i++) {
							data[i].created_at = this.moment(data[i].created_at).format('MMM DD Y HH:mm')
						}
					`,
					special_buttons : ['exportToExcel'],
					update : 0,
					buttons : [
						{
							title : 'cekDetailTransaksi',
							variable : 'workorder_code',
							class : 'btn btn-outline-primary fas fa-sign-out-alt'
						}
					],
					export_config : {
					name : 'Penghasilan',
					type : 'xlsx',
					all : true
					},
				},
			}
		},
		async mounted () {
			this.getAccountList()
			this.options.workorder_code = await this.getWorkOrderCode()
			this.getStatsData();
			
		},
		watch : {
			'selected.date'(){
				var date = this.selected.date.split(" to ");
				this.filter.start = date[0]
				this.filter.end = date[1]
			}
		},
		methods : {
			goToEstimator(x){
				if(x) this.$router.push('/estimator/estimator-application/' + x.replace(/"/g, ""));
				else this.$store.dispatch('triggerAlert', [false, ['An Error has occured']])
			},
			updateData(){
				this.vue_universal_table.update++;
				this.getStatsData();
			},
			getStatsData(){
				this.$http.get(`/api/v1/transactions/summary${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
				.then((resp)=>{
					this.statsData = resp.data.data;
				})
				.catch((err)=>{console.log(err);})
			},
			getAccountList() {
				this.$http.get('/api/v1/transactions/account-list')
				.then((resp) => {
					this.options.accountTransactionList = resp.data.data
				})
				.catch((err) => {
					console.log(err)
				})
			}
		}
    }
  </script>
  
  <style scoped>
  
  </style>